export var DemoozColorPrimary = 'primary';
export var DemoozColorSecondary = 'secondary';
export var DemoozColorBlue = 'blue';
export var DemoozColorRed = 'red';
export var DemoozColorGreen = 'green';
export var DemoozColorOrange = 'orange';
export var DemoozColorPurple = 'purple';
export type DemoozColor = typeof DemoozColorPrimary
    | typeof DemoozColorPrimary
    | typeof DemoozColorBlue
    | typeof DemoozColorRed
    | typeof DemoozColorGreen
    | typeof DemoozColorOrange
    | typeof DemoozColorPurple;